/**
 * Labels for chart-update provenance.
 *
 * `entered_by` is derived server-side from the form response submitter
 * (client / representative / staff) — see
 * `services/clinical/chart_update_provenance.py`. It is display metadata only.
 */
export type EnteredBy = 'client' | 'representative' | 'staff' | 'portal';

const LABELS: Record<EnteredBy, { actor: string; submission: string }> = {
  client: { actor: 'Client', submission: 'client form submission' },
  representative: { actor: 'Representative', submission: 'representative form submission' },
  staff: { actor: 'Staff', submission: 'staff-entered form' },
  portal: { actor: 'Client', submission: 'client portal profile edit' },
};

/** "Client" / "Representative" / "Staff", or "Form" when provenance is unknown. */
export function actorLabel(enteredBy?: string | null): string {
  return LABELS[enteredBy as EnteredBy]?.actor ?? 'Form';
}

/** How the data arrived, e.g. "staff-entered form". */
export function submissionLabel(enteredBy?: string | null): string {
  return LABELS[enteredBy as EnteredBy]?.submission ?? 'form submission';
}
